import { enqueueNotification, errorHandler, getUserInfo } from '../Utils/Helpers'
import { deleteRequest, getRequest, postRequest, putRequest } from './NetworkRequest'

export class credentialInstanceApis {
  /** fetch all credentials List */
  static async getCredentialInstanceList () {
    try {
      const user = getUserInfo()
      const { tenant, apiKey } = user
      const response = await getRequest(apiKey, 'credentials', tenant)
      console.log('getcredentialInstanceList response: ', response)
      return response && response.data ? response.data.Credentials : []
    } catch (error) {
      errorHandler(error, 'getcredentialInstancesList', 'credentialInstanceApis.js')
    }
  }

  static async updatecredentialInstance (data) {
    console.log('updateCredentials: ', data)
    try {
      const user = getUserInfo()
      const { tenant, apiKey, org } = user
      const response = await putRequest(apiKey, `credentials/${org}`, data.ObjectMeta.Name, tenant, data, 'api')
      console.log('response: ', response)
      return response
    } catch (error) {
      errorHandler(error, 'updatecredentialInstance', 'credentialInstanceApis.js')
    }
  }

  static async createcredentialInstance (data) {
    console.log('createCredentials: ', data)
    try {
      const user = getUserInfo()
      const { tenant, apiKey } = user
      const response = await postRequest(apiKey, 'credentials', tenant, data)
      console.log('response: ', response)
      return response
    } catch (error) {
      errorHandler(error, 'createcredentialInstance', 'credentialInstanceApis.js')
    }
  }

  static async deletecredentialInstance (data) {
    try {
      const user = getUserInfo()
      const { tenant, apiKey, org } = user
      const response = await deleteRequest(apiKey, `credentials/${org}`, data.ObjectMeta.Name, tenant, 'api')
      enqueueNotification('Credential Deleted', 'success')
      return response
    } catch (error) {
      errorHandler(error, 'updatecredentialInstance', 'credentialInstanceApis.js')
    }
  }
}
